/**
 * Assumption that the input is repositoryPath and is of the format <workspace>/<repository>.
 * Note: repositoryPath cannot contain '/' and are replaced with '-'
 */
// eslint-disable-next-line import/no-default-export
export default function extractWorkspace(repositoryPath = ''): string {
  return repositoryPath.replace(/\/(.*)$/, '');
}
